import { createAction, props } from '@ngrx/store';
import { MspHaloCreds } from './model';

export const loadMspHaloCreds = createAction('[MSP Halo] Load Creds');
export const loadMspHaloCredsSuccess = createAction(
    '[MSP Halo] Load Creds Success',
    props<{ data: MspHaloCreds; connected: boolean }>(),
);
export const loadMspHaloCredsFailure = createAction('[MSP Halo] Load Creds Failure', props<{ error: any }>());

export const createMspHaloCreds = createAction('[MSP Halo] Create Creds', props<{ data: MspHaloCreds }>());
export const createMspHaloCredsSuccess = createAction(
    '[MSP Halo] Create Creds Success',
    props<{ data: MspHaloCreds }>(),
);
export const createMspHaloCredsFailure = createAction('[MSP Halo] Create Creds Failure', props<{ error: any }>());

export const putMspHaloCreds = createAction('[MSP Halo] Put Creds', props<{ data: MspHaloCreds }>());
export const putMspHaloCredsSuccess = createAction('[MSP Halo] Put Creds Success', props<{ data: MspHaloCreds }>());
export const putMspHaloCredsFailure = createAction('[MSP Halo] Put Creds Failure', props<{ error: any }>());

export const deleteMspHaloIntegration = createAction('[MSP Halo] Delete Integration');
export const deleteMspHaloIntegrationSuccess = createAction('[MSP Halo] Delete Integration Success');
export const deleteMspHaloIntegrationFailure = createAction(
    '[MSP Halo] Delete Integration Failure',
    props<{ error: any }>(),
);
